import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRouteMatch } from 'react-router-dom';

import { reattachService } from '@eir/services';
import { GearSpinner } from '@eir/ui';

import linLogo from '../../images/logo_b.svg';

const AttachView = () => {
  const match = useRouteMatch('/reattach/:paymentProvider/:ledgerId');
  const { paymentProvider } = match.params;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reattchLedger = async () => {
    try {
      const data = await reattachService(
        'LinAPI',
        paymentProvider,
        match.params.ledgerId
      );
      window.location.replace(data.redirectUrl);
    } catch (err) {
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    reattchLedger();
  }, []);

  return (
    <AttachContainer>
      <Header>
        <Logo src={linLogo} alt='lin Försäkring' />
        <h1>{error ? 'Något gick fel' : ''}</h1>
      </Header>
      {loading && (
        <main>
          <GearSpinner
            waitingMessage={`Vänligen vänta, du omdirigeras till ${paymentProvider
              .charAt(0)
              .toUpperCase()}${paymentProvider.slice(1)}..`}
          />
        </main>
      )}
      {error && (
        <main>
          Det gick inte att genomföra betalningen. Vänligen kontakta vår
          kundeservice på telefon <Phone>08 - 520 276 58</Phone> eller e-post
          info@linforsakring.se så hjälper vi dig.
        </main>
      )}
    </AttachContainer>
  );
};

export default AttachView;

const Header = styled.header`
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-bottom: 2.5rem;
  align-items: center;
`;

const Logo = styled.img`
  width: auto;
  height: 6rem;
  margin-bottom: 2rem;
`;

const AttachContainer = styled.div`
  width: 100%;
  max-width: 56.25rem;
  margin: 1.875rem auto;
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;

  main {
    padding: 0.625rem;

    @media (min-width: 48rem) {
      padding: 1.875rem;
    }
  }
`;

const Phone = styled.span`
  white-space: nowrap;
`;
